import axios from "axios";
import { getStoredDeviceInfo } from "../helper/sessionHelper";
import { getStoredUser } from "../helper/sessionHelper";

const getStoredCompany = () => { return { companyId: 1 } } // remove it later and use above commented line.

// Helper function to get current user - called fresh each time
const getCurrentUser = () => getStoredUser();
const getCurrentDeviceInfo = () => getStoredDeviceInfo();

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_VISHWAM_BASE_URL,
  timeout: 100000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    "InternalApiKey": "123",
  },
  //timeout: 5000,
});

// Separate axios instance for refresh token - bypasses interceptors to avoid recursion
const axiosRefreshInstance = axios.create({
  baseURL: process.env.REACT_APP_API_VISHWAM_BASE_URL,
  timeout: 100000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    "InternalApiKey": "123",
  },
});

axiosApi.interceptors.request.use(
  (config) => {
    const user = getCurrentUser();
    const devideInfo = getCurrentDeviceInfo();
    const token = localStorage.getItem("session_accesstoken") || user?.accessToken;
    
    config.headers["Authorization"] = `Bearer ${token}`;
    config.headers["X-User-UserId"] = user?.userId || 0;
    config.headers["X-User-UserName"] = user?.userName || "";
    config.headers["X-User-CompanyId"] = getStoredCompany()?.companyId || 0;
    config.headers["X-IP-Address"] = devideInfo?.iPAddress || "";
    config.headers["X-Device-Info"] = devideInfo?.deviceInfo || "";
    config.headers["X-Is-Browser"] = devideInfo?.isMobile;
    
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  })
  
  isRefreshing = false;
  failedQueue = [];
}

axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("intercepted error---", error);

    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({resolve, reject});
        }).then(token => {
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return axiosApi(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        })
      }

      originalRequest._retry = true;
      isRefreshing = true;

      let token = await refreshAccessToken();
      if (token) {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        processQueue(null, token);
        return axiosApi(originalRequest);
      } else {
        processQueue(error, null);
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem("session_refreshtoken");
    const accessToken = localStorage.getItem("session_accesstoken");

    if (!refreshToken) {
      console.error("No refresh token found in storage");
      return null;
    }

    const request = {
      refreshToken: refreshToken,
      accessToken: accessToken || "",
    };

    console.log("Attempting to refresh token...", { refreshToken: "***", accessToken: accessToken ? "***" : "" });

    const response = await axiosRefreshInstance.post("/Authentication/RefreshJWTToken", request, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("refresh token response", response);

    if (response.status === 200 && response.data?.data) {
      localStorage.removeItem("session_accesstoken");
      localStorage.setItem("session_accesstoken", response.data.data);
      
      // Also update refresh token if provided
      if (response.data?.refreshToken) {
        localStorage.removeItem("session_refreshtoken");
        localStorage.setItem("session_refreshtoken", response.data.refreshToken);
      }
      
      return response.data.data;
    }
    return null;
  } catch (err) {
    console.error("Token refresh failed:", err.response?.data || err.message);
    // Clear stored tokens on refresh failure
    localStorage.removeItem("session_accesstoken");
    localStorage.removeItem("session_refreshtoken");
    return null;
  }
}
// console.log("urll>>>>", process.env.REACT_APP_API_VISHWAM_BASE_URL)

// axiosApi.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("authorize_zenplus_api_token")
//       ? localStorage.getItem("authorize_zenplus_api_token")
//       : null;
//     config.headers["Authorization"] = `Bearer ${token}`;
//     return config;
//   },
//   (error) => {
//     Promise.reject(error);
//   }
// );
// axiosApi.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       let token = await refreshAccessToken();
//       originalRequest.headers.Authorization = `Bearer ${token}`;
//       return axios(originalRequest);
//     }
//     return Promise.reject(error);
//   }
// );
// async function refreshAccessToken() {
//   const request = {
//     SecretKey: process.env.REACT_APP_ZENPLUS_API_SECRET_KEY,
//   };
//   var response = await axiosApi
//     .post("/authorize/token", request, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//     .then((res) => res);
//   if (response.status === 200) {
//     localStorage.removeItem("authorize_zenplus_api_token");
//     localStorage.setItem("authorize_zenplus_api_token", response.data);
//     return response.data;
//   }
//   return null;
// }
export default axiosApi;
